const UserPermissions = {
    RunPlaybook: "dioptra::run_playbooks",
    ManagePlaybooks: "dioptra::manage_playbooks",
    UseClauses: "dioptra::use_clauses",
    ManageClauses: "dioptra::manage_clauses",
}

export default UserPermissions;
